import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import LennocComponents from '@lennoc/lennoc-components'
import FormFactory from '@/components/composed/FormFactory.vue'
import ClaimLegalRepresentative from './components/person/ClaimLegalRepresentative.vue'

Vue.config.productionTip = false

Vue.use(LennocComponents, { spritepath: process.env.VUE_APP_SVG_SPRITE_PATH })

Vue.component('form-factory', FormFactory)
Vue.component('claim-legal-representative', ClaimLegalRepresentative)

const requireComponent = require.context(
  '@/components/base', false, /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(
    camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )
  Vue.component(
    componentName, componentConfig.default || componentConfig
  )
})

Vue.config.errorHandler = function (err, vm, info) {
  // console.log(err, vm, info)
  try {
    if (Vue.config.devtools === true) {
      console.log(err)
    }
    store.dispatch('log/exception', `{"Source": "Portal.Frontend", "Info": "${info}", "Error": "${err.toString()}", "StackTrace": "${err.stack.toString()}"}`)
  } catch (error) {
    // Fire and forget the call to the external log API
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#client-portal')
